import { Injectable } from '@angular/core';
import { AdminService } from '@mitel/cloudlink-sdk/admin';
import { AuthenticationService } from '@mitel/cloudlink-sdk/authentication';
import { Config, HttpMethod } from '@mitel/cloudlink-sdk';
import { BillingService } from '@mitel/cloudlink-sdk/billing';
import { environment } from '../../environments/environment';
import { TunnelService } from '@mitel/cloudlink-sdk/tunnel';

/**
 * Your gateway to CloudLink Services.
 * This service assumes that Config.global has been assigned elsewhere, probably in main.ts.
 * But if it is not, we assign it here. (This is helpful for running unit tests.)
 */
@Injectable({
  providedIn: 'root',
})
export class CloudLinkService {
  get adminService(): AdminService {
    this._adminService ??= this._config.getMicroService(AdminService);
    return this._adminService;
  }

  get authenticationService(): AuthenticationService {
    this._authentication ??= this._config.getMicroService(AuthenticationService);
    return this._authentication;
  }

  get billingService(): BillingService {
    this._billingService ??= this._config.getMicroService(BillingService);
    return this._billingService;
  }

  get config(): Config {
    return this._config;
  }

  get http(): HttpMethod {
    return this._config.getHttpService();
  }

  get tunnelService(): TunnelService {
    this._tunnelService ??= this._config.getMicroService(TunnelService);
    return this._tunnelService;
  }

  private _authentication: AuthenticationService;
  private _adminService: AdminService;
  private _billingService: BillingService;
  private _config: Config;
  private _tunnelService: TunnelService;

  constructor() {
    Config.global ??= new Config({
      appInfo: environment.appInfo,
      cloud: environment.cloud,
      requestTimeoutMilliseconds: 30000,
      stage: environment.stage as any,
    });
    this._config = Config.global;
  }
}
